<template>
	<div id="zbmx" v-loading="loading">
		<div class="zbmx_main">
			<!-- 彩票类型 -->
			<div class="query_info">
				<!-- 选择账单类别 -->
				<el-select v-model="currBillTypes" placeholder="请选择账单类别">
					<el-option v-for="item in billTypes" :key="item.Value" :label="item.Name" :value="item.Value" />
				</el-select>
				<!-- 订单编号 -->
				<el-date-picker
					v-model="beginDate"
					type="datetime"
					value-format="yyyy-MM-dd HH:mm:ss"
					placeholder="开始日期"
					class="czdateStyle"
				/>
				<el-date-picker
					v-model="endDate"
					type="datetime"
					value-format="yyyy-MM-dd HH:mm:ss"
					placeholder="结束日期"
					class="czdateStyle"
				/>
				<el-button class="el-button--primary" @click="zbCxBtn">搜索</el-button>
			</div>
			<!-- 彩票的表格 -->
			<div class="czTable">
				<!-- 彩票表格 -->
				<el-table :data="czTableData" border stripe style="width: 100%">
					<el-table-column prop="OpTypeText" label="账单类别" />
					<el-table-column prop="OpMoney" label="账变金额" />
					<el-table-column prop="NowMoney" label="当前余额" />
					<el-table-column prop="Remark" label="备注说明" width="470" />
					<el-table-column prop="OpTime" label="账变时间" width="170" />
					<div slot="empty">
						<!-- 表格为空的样式 -->
						<div class="table-empty">
							<img src="@/static/img/zjzh/empty.png" alt="" />
							<div class="table-empty-text">暂无记录</div>
						</div>
					</div>
				</el-table>
			</div>
			<div class="my-paging" v-show="czTableData.length != 0">
				<div class="everyPageShow">每页显示 10 条</div>
				<div class="totalNum">共{{ paginationArray.total }}条</div>

				<el-pagination
					@current-change="handleCurrentChange"
					:page-size="paginationArray.currpageSize"
					layout="prev, pager, next, jumper"
					:total="paginationArray.total"
					background
				/>
			</div>
		</div>
	</div>
</template>
<script>
// 引用axios封装文件
import { postAjax, getAjax } from "../../util/ajax.js";

export default {
	data() {
		return {
			loading: false,
			//显示弹框
			dialogVisible: true,
			//账单类别
			billTypes: [],
			currBillTypes: "",
			//投注期号
			betIssue: "",
			//订单编号
			orderNum: "",
			//日期
			beginDate: "",
			endDate: "",
			//表格数据
			czTableData: [],
			// czTableData:[],
			paginationArray: {
				total: 0,
				currpageSize: 10,
				currPage: 1, //当前页数
			},
			//每页展示多少条
			pageSize: [
				{ value: 10, label: "10条" },
				{ value: 20, label: "20条" },
				{ value: 30, label: "30条" },
			],
		};
	},
	methods: {
		initDate() {
			let etad = new Date();
			let y = etad.getFullYear();
			let m = ("00" + (etad.getMonth() + 1)).slice(-2);
			let d = etad.getDate();
			let h = etad.getHours();
			d = h > 3 ? d : d - 1;
			this.beginDate = `${y}-${m}-${("00" + d).slice(-2)} 03:00:00`;
			this.endDate = `${y}-${m}-${("00" + (d + 1)).slice(-2)} 03:00:00`;
		},
		//改变分页条数
		pageChange(val) {
			this.paginationArray.currpageSize = val;
			this.zbCxBtn();
		},
		getBillType() {
			let that = this;
			that.billTypes = [{ Name: "全部", LgId: "" }];
			let url = "api/Sys/GetUserAccTypeList";
			postAjax(url, null).then(function (data) {
				if (data.IsSucess) {
					that.billTypes.push(...data.Data);
					that.zbCxBtn();
				}
			});
		},
		//查询
		zbCxBtn() {
			let that = this;
			let url = "api/Order/PUserAccInfo";
			let data = {
				BetNumber: this.orderNum,
				EndTime: this.endDate,
				OpType: this.currBillTypes,
				PIndex: this.paginationArray.currPage,
				PSize: this.paginationArray.currpageSize,
				StartTime: this.beginDate,
			};
			this.loading = true;
			postAjax(url, data)
				.then(data => {
					this.loading = false;
					if (data.IsSucess) {
						that.czTableData = data.Data.rows;
						that.paginationArray.total = data.Data.total;
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},
		handleCurrentChange(e) {
			//回调为当前跳转的第几页
			this.paginationArray.currPage = e;
			this.zbCxBtn();
		},
		//时间格式化
		formatDate(row, column) {
			if (row[column.property]) {
				var arr = row[column.property].split("T");
				var arr1 = arr[1].split(".");
				return arr[0] + " " + arr1[0];
			} else {
				return "-";
			}
		},
	},
	mounted() {
		this.initDate();
		this.getBillType();
	},
};
</script>
<style type="scss">
.zbmx_main {
	padding: 20px 0px 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderReport/zbmx.vue